// Brunch / Sunday morning stubs — late-morning weekend eating,
// often co-tagged with Easter when egg-forward.

export const BRUNCH_STUBS = [
  {
    id: "buttermilk-pancakes",
    title: "Buttermilk Pancakes",
    emoji: "🥞",
    blurb: "Fluffy stack with maple syrup and butter",
    discoveryTags: ["brunch", "sunday-morning", "kids", "easter", "weeknight"],
    cuisine: "american",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["flour", "buttermilk", "eggs", "butter", "maple_syrup"],
    buildHint: "do not overmix — small lumps are good; let batter rest 5 min for fluffier rise; cook on medium until bubbles set then flip once",
    producesCanonical: null,
  },
  {
    id: "eggs-benedict",
    title: "Eggs Benedict",
    emoji: "🍳",
    blurb: "Poached eggs on English muffin with hollandaise",
    discoveryTags: ["brunch", "sunday-morning", "date-night", "easter"],
    cuisine: "american",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "medium",
    estimatedTime: 30,
    keyIngredients: ["eggs", "english_muffin", "canadian_bacon", "butter", "lemon"],
    buildHint: "hollandaise is the whole game — blender method for reliability, room-temp eggs for poaching at gentle simmer with vinegar splash, assemble fast",
    producesCanonical: null,
  },
  {
    id: "french-toast",
    title: "French Toast",
    emoji: "🍞",
    blurb: "Custard-soaked bread, crisp edges, powdered sugar",
    discoveryTags: ["brunch", "sunday-morning", "kids", "weeknight"],
    cuisine: "french",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 20,
    keyIngredients: ["bread", "eggs", "milk", "butter", "maple_syrup"],
    buildHint: "thick-cut day-old brioche or challah is ideal, custard heavy on yolks for richness, butter in pan medium heat for golden crust",
    producesCanonical: null,
  },
  {
    id: "avocado-toast",
    title: "Avocado Toast",
    emoji: "🥑",
    blurb: "Smashed avocado, lemon, chili flakes, good bread",
    discoveryTags: ["brunch", "sunday-morning", "weeknight", "meal-prep"],
    cuisine: "american",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 10,
    keyIngredients: ["bread", "avocado", "lemon", "red_pepper_flakes"],
    buildHint: "great bread is non-negotiable — sourdough or country loaf toasted hard; smash avocado with lemon, flaky salt, optional poached or fried egg on top",
    producesCanonical: null,
  },
  {
    id: "breakfast-burrito",
    title: "Breakfast Burrito",
    emoji: "🌯",
    blurb: "Scrambled eggs, cheese, potatoes, salsa in a flour tortilla",
    discoveryTags: ["brunch", "sunday-morning", "kids", "weeknight", "meal-prep"],
    cuisine: "mexican",
    course: "main",
    mealTiming: "breakfast",
    difficulty: "easy",
    estimatedTime: 25,
    keyIngredients: ["eggs", "flour_tortilla", "cheddar", "potatoes", "salsa"],
    buildHint: "scramble eggs soft and pull early — they keep cooking off heat, crispy roasted potato cubes, warm tortilla on dry skillet before wrapping",
    producesCanonical: null,
  },
];
